// extracted by mini-css-extract-plugin
export var actionButton = "_ca-5";
export var actionButtonActive = "_ca-6";
export var content = "_ca-3";
export var header = "_ca-4";
export var list = "_ca-7";
export var settingsContent = "_ca-a";
export var settingsPanel = "_ca-b";
export var settingsRow = "_ca-c";
export var state = "_ca-9";
export var triggerBadge = "_ca-2";
export var triggerButton = "_ca-1";
export var triggerShell = "_ca-0";
export var unreadDot = "_ca-8";